import { GlobalController } from 'src/shared/global/GlobalController'
import AgreementReport from './AgreementReport.vue'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'agreement-report',
    component: AgreementReport,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
